var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _vm.indirizzo
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "body current",
                attrs: {
                  id: "wizard2-p-0",
                  role: "tabpanel",
                  "aria-labelledby": "wizard2-h-0",
                  "aria-hidden": "false",
                },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.indirizzo.denominazione))]),
                    _vm._v(" "),
                    _vm.indirizzo.citofono && _vm.indirizzo.citofono != ""
                      ? _c("span", [
                          _vm._v("Citofono: " + _vm._s(_vm.indirizzo.citofono)),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.indirizzo.indirizzo) +
                        " " +
                        _vm._s(_vm.indirizzo.comune) +
                        " " +
                        _vm._s(_vm.indirizzo.provincia) +
                        " " +
                        _vm._s(_vm.indirizzo.cap)
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _vm.indirizzo.telefono && _vm.indirizzo.telefono != ""
                      ? _c("span", [
                          _vm._v("Telefono: " + _vm._s(_vm.indirizzo.telefono)),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.indirizzo.cellulare && _vm.indirizzo.cellulare != ""
                      ? _c("span", [
                          _vm._v(
                            "Cellulare: " + _vm._s(_vm.indirizzo.cellulare)
                          ),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.indirizzo.email && _vm.indirizzo.email != ""
                      ? _c("span", [
                          _vm._v("Email: " + _vm._s(_vm.indirizzo.email)),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n          Confermi che i dati sono corretti?\n        "
                    ),
                  ]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("buttons", {
        attrs: { buttons: _vm.step.buttons },
        on: { action: _vm.fireaction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }